/* eslint-disable jsx-a11y/anchor-is-valid */

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  Group,
  InfoOutlined,
} from '@mui/icons-material';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { getBarnUsersForAssignmentString } from '../../../../../utils/scheduleHelper';
import BarnUsersAutocomplete from '../../../../Autocompletes/BarnUsers';
import User from '../../../../User';

const ScheduleParticipant = ({
  schedule,
  event,
  assignment,
  setAssignment,
  type,
  disabledForBeingInPast,
  name,
  setName,
}) => {
  const [editParticipants, setEditParticipants] = React.useState(false);

  React.useEffect(() => {
    setEditParticipants(false)
  }, [schedule, event])

  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const listItemSx = {
    px: 1,
    py: 0.75,
  };
  const listItemIconSx = {
    minWidth: 32,
    mr: 0.75,
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
      height: '1.25rem',
      width: '1.25rem',
    },
  };

  return (
    <ListItem dense sx={listItemSx}>
      <ListItemIcon sx={listItemIconSx}><Group /></ListItemIcon>
      <ListItemText>
        {
          !editParticipants
            ? (
              <Tooltip
                title={type === 'Invitation'
                  ? 'Remove any participants and cancel their calendar invites'
                  : 'Invite participants and send them a calendar invite for this task'}
              >
                <Grid container>
                  {
                    getBarnUsersForAssignmentString(assignment || '', barnUsersMap).map((bu) => (
                      <Grid><User key={`task-assignment-${bu.id}`} user={bu} chip sx={{ mr: 0 }} /></Grid>
                    ))
                  }
                  <Grid>
                    <Link
                      component="button"
                      variant="body2"
                      color="secondary"
                      underline="hover"
                      onClick={() => {
                        setAssignment(!assignment
                          ? ''
                          : assignment);
                        setEditParticipants(true)
                      }}
                    >
                      {(assignment && assignment.length > 0)
                        ? 'Modify Participant(s)'
                        : 'Add Participant(s)'}
                    </Link>
                  </Grid>
                </Grid>
              </Tooltip>
            )
            : (
              <Box>
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <BarnUsersAutocomplete
                      label="Participant(s)"
                      id="barn-users-select-autocomplete-schedule-assignment"
                      multiple
                      focusOnMount
                      value={getBarnUsersForAssignmentString(assignment || '', barnUsersMap)}
                      onSelect={(e, newBarnUsers) => {
                        const newBarnUsersString = newBarnUsers.map((bu) => (bu.id
                          ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                          : `@[${bu.userFullName || bu}](${null})`)).join('');
                        setAssignment(newBarnUsersString);

                        // const updatedWorkflows = workflows;
                        // updatedWorkflows[index].scheduleAssignment = newBarnUsersString;

                        // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                        // setAssignment(updatedWorkflows.map((ww) => ww.scheduleAssignment || '').join(''));

                        // Now assign to the workflow
                        // setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                      }}
                      limitTags={(schedule && schedule.id)
                        ? 2
                        : 5}
                      disabled={disabledForBeingInPast}
                    />
                  </Box>
                  {
                    assignment && assignment.length > 0 && (
                      <Box sx={{ textAlign: 'right' }}>
                        <Button
                          size="small"
                          sx={{
                            fontSize: 11,
                            pt: 0,
                          }}
                          disabled={disabledForBeingInPast}
                          onClick={() => {
                            const names = getBarnUsersForAssignmentString(assignment || '', barnUsersMap)
                            if (name.indexOf(' - ') > 0) {
                              setName(`${name.substring(0, name.indexOf(' - '))} - ${names.map((bu) => bu.userFullName).join(' | ')}`)
                            } else {
                              setName(`${name} - ${names.map((bu) => bu.userFullName).join(' | ')}`)
                            }
                          }}
                        >Add name to title
                        </Button>
                      </Box>
                    )
                  }
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Tooltip
                    title="Remove any participants for this task"
                  >
                    <Link
                      component="button"
                      variant="body2"
                      color="secondary"
                      disabled={disabledForBeingInPast}
                      underline="hover"
                      onClick={() => {
                        setAssignment(null);
                        setEditParticipants(false)
                      }}
                    >
                      Remove Participants
                    </Link>
                  </Tooltip>
                </Box>
              </Box>
            )
        }
      </ListItemText>
      <Tooltip title="Participants are not assigned the task, but allow you to associate the task with individuals other than the task assigned users. For example, a client, rider, or someone else not part of your organization.">
        <InfoOutlined
          sx={{
            ml: 1,
            fontSize: 20,
          }}
          color="secondary"
        />
      </Tooltip>
    </ListItem>
  )
};

ScheduleParticipant.propTypes = {
  schedule: PropTypes.object,
  event: PropTypes.object,
  assignment: PropTypes.string,
  setAssignment: PropTypes.func,
  type: PropTypes.string.isRequired,
  disabledForBeingInPast: PropTypes.bool,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
};

ScheduleParticipant.defaultProps = {
  schedule: null,
  event: null,
  assignment: '',
  setAssignment: () => { },
  disabledForBeingInPast: false,
};

export default ScheduleParticipant;
